module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_karuizawa-3586f5b100098324e1ed836006aede99.jpg";